<template>
<!--  <Panel :header="$t('returnsStatisticsLabel') + (periodLabel ? ' (' + periodLabel + ')' : '')"-->
<!--         toggleable-->
<!--         :collapsed="isCollapsed"-->
<!--         @toggle="togglePanel">-->
  <Panel :collapsed="isCollapsed" toggleable @toggle="togglePanel">
    <template #header>
      <div class="statistics-panel-header">
        <b>{{ $t('returnsStatisticsLabel') }}</b>
        <span v-if="periodLabel" class="p-text-secondary statistics-panel-date p-mr-2">
          {{ periodLabel }}
        </span>
      </div>
    </template>
    <Spinner v-if="showSpinner" :isSmall="true" :spinnerStyle="'margin: 20px auto'"/>
    <template v-else-if="returns?.length">
      <div v-for="(manager, index) of returns"
           :key="index"
           class="datatable-wrapper"
           :class="{'p-mt-5': returns.length > 1 && index > 0}">
        <ReturnsPanelTable :fromTimestamp="fromTimestamp"
                           :toTimestamp="toTimestamp"
                           :manager="manager"/>
      </div>
    </template>
    <div v-else style="text-align: center; padding: 20px;">
      {{ $t('No data available' )}}
    </div>
  </Panel>
</template>

<script>
import httpClient from "@/services/http.services";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import ReturnsPanelTable from "@/pages/overview/components/ReturnsPanelTable";

export default {
  mixins: [ showErrorsMixins ],
  components: { ReturnsPanelTable },
  name: 'ReturnsPanel',
  props: {
    periodLabel: { type: String, default: '' },
    // managerSales: {
    //   type: Array,
    // },
    isWarrantyPanel: {
      type: Boolean,
      default: false,
    },
    dataTableIsLoading: {
      type: Boolean,
      default: false,
    },
    fromTimestamp: {
      type: Number,
      default: null,
    },
    toTimestamp: {
      type: Number,
      default: null,
    },
  },
  watch: {
    dataTableIsLoading(boolean) {
      if (boolean) {
        this.isCollapsed = true
        this.returns = []
      }
    },
  },
  data: () => {
    return {
      returns: [],
      showSpinner: false,
      isCollapsed: true,
    }
  },
  methods: {
    togglePanel(event) {
      if (!event) return
      const value = !event.value
      this.isCollapsed = !value
      if (value) {
        this.getStatistics()
      }
    },
    async getStatistics() {
      if (this.showSpinner) return
      this.showSpinner = true
      try {
        const { status, data } = await httpClient({
          url: 'statistics/get-returns-statistics',
          method: 'post',
          // params: {
          data: {
            dateFrom: this.fromTimestamp,
            dateTo: this.toTimestamp,
          }
        })

        if (status === 200 && data) {
          this.returns = data.returns || []
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.showSpinner = false
      }
    },
  }
}
</script>

<style scoped lang="scss">
.datatable-wrapper {
  overflow-y: auto;
}
</style>